import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../hooks/hooks";
import { selectVenturesListItems } from "../../../../redux/ventures/selector";
import { ventures } from "../../../../redux/ventures/action";
import PageLoader from "../../../../components/PageLoader";
import Table from "../../../../common/components/table-manager/v1.1/table";
import storePersist from "../../../../redux/storePersist";
import { generatePin } from "../../../../redux/auth/actions";


const ManagementVentures = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [pageData, setPageData] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const venturesItemsData = useSelector(selectVenturesListItems);
    const [columnDefs, setColumnDefs] = useState({});
     const [baseUrl, setBaseUrl] = useState('');
  const tenatId = storePersist?.get("accessTokenMetadata")?.current?.TokenMetadata?.TenantId;
  const [launchId, setLaunchId] = useState<any>()
  const [launchLabel, setLaunchLabel] = useState<any>()


    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(params.node.id, 10) + 1;
                },
            },
            { field: 'UserName', headerName: 'Name',searchField: 'UserName', sortable: true, filter: true, filterType: 'text' },
            { field: 'Email', headerName: 'Email'}, 
            { field: 'PhoneNumber', headerName: 'Phone Number'},
             { field: 'IsGuestAccessEnabled', headerName: 'Access Enabled', cellRenderer: 'yesNoRenderer' },
              { field: 'IsLaunchedToSCP', headerName: 'Login To Venture application', isLaunched: true },
     
            { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
            { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true },
        ]);
    };

    const fetchVenturesList = () => {
        dispatch(ventures.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/ventures/list`,
            entity: 'ventures',
            jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc"
            }
        }));
    };

    useEffect(() => {
        createColumnDefs();
        fetchVenturesList();
        setBaseUrl(window.location.origin);
    }, [pageData, pageSize]);


    const handleAdd = () => {
        navigate(`${0}`);
    };

    

    const handleDelete = (data: any) => {
        dispatch(ventures.delete({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/ventures/delete`,
            entity: 'ventures',
            jsonData: {
                Records: [
                    {
                        Id: data?.Id
                    }
                ]
            }
        })).then(() => {
            fetchVenturesList();
        });
    };

    const handleEdit = (data: any) => {
        navigate(`${data?.Id}`)
      }
      const handleReloadData = () => {
        fetchVenturesList()
      }
      const additionButtons: any = [
        {
          svg:
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
              <title>Add Ventures</title>
              <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
            </svg>,
          callback: () => handleAdd(),
        },
        
        {
          svg:
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
              <title>Reload this table</title>
              <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>,
          callback: () => handleReloadData(),
        },
      ];
    
      const handleSearch = (data: any) => {
        let searchCriteria = {};
        if (data?.column) {
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Name",
            FieldText: "Name",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } 

        dispatch(ventures.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/ventures/list`,
            entity: 'ventures',
            jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc",
                "Searches": searchCriteria,
              }
        }));
    };

    const handleGeneratePin = async (dataId: any) => {
    try {
      const metaData: any = storePersist.get("metaTokenMetaData");
      const accountId = dataId?.AccountInfo?.AccountId;
      const response = await dispatch(generatePin({
        loginData: {
          Records: [
            {
              Context: {
                "Subscription": "ONEX",
                "Domain": "ONE",
                "SubDomains": [],
                "Network": "Venture",
                "Application": "Venture",
                "Channel": "CSP",
              },
              Message: {
                Id: dataId?.AccountInfo?.AccountId,
                TenantId: tenatId,
                SalesChannelName: 'CSP',
                AccountType: "Venture",
                OrganizationUnitId: metaData?.current?.items?.Website?.OUId
              }
            }
          ]
        }
      }))
      setLaunchId(dataId?.AccountInfo?.AccountId)
      setLaunchLabel(response?.result)
    } catch (e) {
      // toast.error('Error generating pin')
    }
  }

    return (
        <>
            {venturesItemsData?.isLoading ? 
                <PageLoader /> :
                <Table 
                checkboxConfig={{
                    allowMultiSelect: true,
                    defaultSelectedIds: [],
                    isDisabled: false,
                    keyColumn: 'Id',
                  }}
                    columnData={columnDefs} 
                    rowData={venturesItemsData?.result?.items} 
                    setPageData={setPageData}
                    setPageSize={setPageSize}
                    enableFilter={true}
                     onSearch={handleSearch} 
                    paginationData={venturesItemsData?.result?.pagination}
                    additionButtons={additionButtons} 
                    onEdit={handleEdit} 
                      launchId={launchId}
          launchLabel={launchLabel}
          onGeneratePin={handleGeneratePin}
          baseUrl={baseUrl}
                
                    headingName="Ventures" 
                />
            }
        </>
    );
};

export default ManagementVentures;
